/* CPU architecture helpers: devices report uname -m (aarch64 / x86_64), images are tagged arm64 / amd64 */
export const archOf = (s?: string | null): string => {
  const n = String(s || "").toLowerCase();
  if (n.includes("arm64") || n.includes("aarch64")) return "arm64";
  if (n.includes("amd64") || n.includes("x86_64")) return "amd64";
  return "";
};
/* an image with an unknown architecture is allowed anywhere (the backend decides) */
export const archFits = (imgArch?: string | null, nodeArch?: string | null) => {
  const a = archOf(imgArch), b = archOf(nodeArch);
  return !a || !b || a === b;
};
